/**
 * Import api
 */
import api from '../../api';


/**
 * Define state
 * @type {{currentUserInfo: null, isAuthenticated: boolean}}
 */
const state = {
    newsList: [],
    pagination: {}
};


/**
 * Define getters
 * @type {{}}
 */
const getters = {

};


/**
 * Define actions
 * @type {{}}
 */
const actions = {
    /**
     * Get news list
     * @param commit
     * @param currentPage
     * @returns {Promise<void>}
     */
    async getNewsList({commit}, currentPage = 1) {
        await api.getNewsList(currentPage)
            .then((response) => {
                commit('GET_NEWS_SUCCESSFULLY', response.data);
            })
    }
};


/**
 * Define mutations
 * @type {{}}
 */
const mutations = {

    /**
     * Get news successfully
     * @param state
     * @param data
     * @constructor
     */
    GET_NEWS_SUCCESSFULLY(state, data) {
        state.newsList = data.data;
        state.pagination = data.pagination;
    }
};


/**
 * Export module
 */
export default {
    state,
    getters,
    actions,
    mutations
}
